import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { retry, tap } from "rxjs/operators";
import { SubDistrict, Address } from "../model/address.model";

@Injectable({ providedIn: "root" })
export class AddressService {
  #http = inject(HttpClient);
  private excepted_key_names: string[] = [];

  private apiAddressUrl = "/addresses";
  private apiSubDistrictUrl = "/sub_districts";

  _setFilter(obj: any) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v != null)
    );
  }

  _setParams(value: any) {
    if (!value) return;
    const filter: any = this._setFilter(value);
    let params = new HttpParams();
    for (const key in filter) {
      if (Array.isArray(filter[key])) {
        params = params.append(key, JSON.stringify(filter[key]));
      } else {
        params = params.append(key, filter[key]);
      }
    }
    return params;
  }
  _setFormData(object_key: string, value: any) {
    let formData = new FormData();
    for (const key in value) {
      let obj = value[key];
      if (Array.isArray(obj)) {
        obj.forEach((e, i) => {
          if (this.excepted_key_names.includes(key)) {
            formData.append(`${object_key}[${key}][]`, e);
          } else {
            for (const key_i in e) {
              formData.append(`${object_key}[${key}][][${key_i}]`, e[key_i]);
            }
          }
        });
      } else {
        formData.append(`${object_key}[${key}]`, value[key]);
      }
    }
    return formData;
  }

  // getDataByPostCode(code: number): Observable<SubDistrict[]> {
  //   return this.#http.get<SubDistrict[]>(`/sub_districts?post_code=${code}`);
  // }

  getSubDistrict(id: number): Observable<SubDistrict> {
    return this.#http.get<SubDistrict>(`${this.apiSubDistrictUrl}/${id}`);
  }

  getAddresses(filter?: any): Observable<Address[]> {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<Address[]>(`${this.apiAddressUrl}/current`)
      .pipe(retry(1));
  }
  createAddress(data: Address): Observable<Address> {
    let payload = { address: data };
    return this.#http.post<Address>(`${this.apiAddressUrl}`, payload);
  }
  updateAddress(id: number, data: Address): Observable<Address> {
    let payload = { address: data };
    return this.#http.put<Address>(`${this.apiAddressUrl}/${id}`, payload);
  }
  deleteAddress(id: number): Observable<Address> {
    return this.#http.delete<Address>(`${this.apiAddressUrl}/${id}`);
  }
}
